import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const GENERIC = "Algo no ha salido bien. Tu trabajo sigue aquí. Puedes intentarlo de nuevo.";

function msg(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace("Value error, ", "");
  return GENERIC;
}

export const api = {
  async crearLead(payload) {
    try {
      const { data } = await client.post("/leads", payload);
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
  async disponibilidad() {
    try {
      const { data } = await client.get("/disponibilidad");
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
  async crearSolicitud(payload) {
    try {
      const { data } = await client.post("/solicitudes", payload);
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
  async verify(key) {
    try {
      await client.get("/admin/verify", { headers: { "x-owner-key": key } });
      return { ok: true };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
  async listarLeads(key, q) {
    try {
      const { data } = await client.get("/admin/leads", {
        headers: { "x-owner-key": key },
        params: q ? { q } : {},
      });
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
  async verLead(key, id) {
    try {
      const { data } = await client.get(`/admin/leads/${id}`, {
        headers: { "x-owner-key": key },
      });
      return { ok: true, data };
    } catch (err) {
      return { ok: false, error: msg(err) };
    }
  },
};
